import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

export const collection = 'groups'

export const schema = new schemas.Entity(collection)

/**
 * @deprecated Use group/remove instead.
 * Will be removed in https://jira.tools.sap/browse/SIGPG-5786
 */

export const remove =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: { id: string }) => {
    return callApi(`${apiBase}/groups/${id}`, schema, { method: 'DELETE' })
  }
